import { TENANT_FR, TENANT_IT } from 'shared/consts'
import { type Tenant } from 'types/shopConfig'

type GetDiscountToShowProps = {
  tenant: Tenant
  discount: number
}

export const getDiscountToShow = ({
  tenant,
  discount,
}: GetDiscountToShowProps) => {
  if (Number.isNaN(discount)) return null

  const tenantsToHideSmallDiscount = [TENANT_IT, TENANT_FR]
  const isTenantToHide = tenantsToHideSmallDiscount.includes(tenant)
  return isTenantToHide && discount <= 1 ? null : discount
}
